<script setup lang="ts">
const { clientTokenCookie } = useSelf()

useHead({
  title: "Poly: The Intelligent Cloud File Browser | Join the Waitlist",
  bodyAttrs: {
    class: "text-$global-t-default text-base bg-$page-bg-primary-desktop",
  },
})

onMounted(async () => {
  if (clientTokenCookie.value)
    return await navigateTo("/home")
})
</script>

<template>
  <nuxt-page />
</template>
